export default function productType(event){
    let winePLP = 'fine-wine';
    let spiritPLP = 'fine-spirits';
    var dropdownValue = $(event.currentTarget).val();

    switch (dropdownValue) {
        case "sparkling":
            window.location.href = `/${winePLP}/type/sparkling`;
            return;
        case "fortified":
            window.location.href = `/${winePLP}/type/fortified`;
            return;
        case "wine":
            window.location.href = `/${winePLP}/all`;
            return;
        case "spirit":
            window.location.href = `/${spiritPLP}/all`;
            return;
    }

    event.data.loadPLP();
}